import React, { useState, useEffect } from 'react';
import { Layout, Spin } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import GlobalHeader from '../components/global-header';
// import SiderMenu from '@/components/sider-menu';
// import { getMenuData } from '@/common/util';
import './index.less';

const { Header, Content } = Layout;

const avatarMenu = [{
  title: '退出登录',
  key: 'logout',
  icon: <LogoutOutlined />,
}];

const MainContainerLayout = ({ loading, setGlobalState, currentUser, schools, menus }) => {
  // const { currentUser } = useSelector(state => state.user);
  // const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(true);
  const handleCollapseMenu = () => {
    setCollapsed(!collapsed);
    setGlobalState({ collapsed });
  };

  const handleClickAvatarMenu = ({ key }) => {
    if (key === 'logout') {
      history.push(`/login?redirect=${encodeURIComponent(location.pathname)}`);
      // localStorage.clear();
    }
  };
  const handleActiveChange = (index) => {
    setGlobalState && setGlobalState({ activeMenuIndex: index });
  };
  return (
    <Layout>
      <GlobalHeader
        collapsed={collapsed}
        currentUser={currentUser}
        schools={schools}
        menus={menus}
        onClickAvatarMenu={handleClickAvatarMenu}
        onCollapseMenu={handleCollapseMenu}
        onActiveChange={handleActiveChange}
        loading={loading}
        avatarMenu={avatarMenu} />
      <Content id="sub-app-viewport">
        {
          loading ? (
            <div className="nbugs-main-container-loading">
              <div className="img-box"><img src="https://img.alicdn.com/tps/i3/TB1VG6aHXXXXXXZXpXX2GPaIVXX-80-80.gif" alt="" /></div>
            </div>
          ) : (
            <div id="sub-app-viewport"></div>
          )
        }
      </Content>
    </Layout>
  );
};

export default MainContainerLayout;
